/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessCreateRequest } from '../models/BusinessCreateRequest';
import type { BusinessResponse } from '../models/BusinessResponse';
import type { BusinessUpdateRequest } from '../models/BusinessUpdateRequest';
import type { PaginatedResponse_BusinessResponse_ } from '../models/PaginatedResponse_BusinessResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessService {
    /**
     * Create Business
     *     사업 생성
     *
     * 새로운 사업을 생성합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns BusinessResponse Created
     * @throws ApiError
     */
    public static appsBusinessViewsCreateBusiness({
        requestBody,
    }: {
        requestBody: BusinessCreateRequest,
    }): CancelablePromise<BusinessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Businesses
     * 사업 목록 조회 및 검색 (필터링 기능 포함)
     *
     * 워크스페이스 내 사업을 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * include_unavailable: 비활성 사업 포함 여부 (기본값: False)
     * - True인 경우 owner 또는 admin 권한 필요
     * q: 검색 키워드 (선택사항) - 사업명으로 검색
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_BusinessResponse_ OK
     * @throws ApiError
     */
    public static appsBusinessViewsListBusinesses({
        workspaceId,
        includeUnavailable = false,
        q,
        page = 1,
        perPage = 100,
    }: {
        workspaceId: string,
        includeUnavailable?: boolean,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_BusinessResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business',
            query: {
                'workspace_id': workspaceId,
                'include_unavailable': includeUnavailable,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Business
     * 사업 조회
     *
     * ID로 특정 사업을 조회합니다.
     * @returns BusinessResponse OK
     * @throws ApiError
     */
    public static appsBusinessViewsGetBusiness({
        businessId,
    }: {
        businessId: string,
    }): CancelablePromise<BusinessResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/{business_id}',
            path: {
                'business_id': businessId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Business
     *     사업 정보 수정
     *
     * 특정 사업의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns BusinessResponse OK
     * @throws ApiError
     */
    public static appsBusinessViewsUpdateBusiness({
        businessId,
        requestBody,
    }: {
        businessId: string,
        requestBody: BusinessUpdateRequest,
    }): CancelablePromise<BusinessResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/business/{business_id}',
            path: {
                'business_id': businessId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Business
     *     사업 삭제
     *
     * 특정 사업을 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsBusinessViewsDeleteBusiness({
        businessId,
    }: {
        businessId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/business/{business_id}',
            path: {
                'business_id': businessId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
